import { PerspectiveCamera, Texture, Vector2, WebGLRenderer } from "three";
import Scene from "./WorldScene";


export default class Renderer extends WebGLRenderer {
  private declare isLandscape: boolean;

  sizeVector = new Vector2();
  currentPixelRatio = Math.max(window.devicePixelRatio, 2);

  constructor() {
    super({ powerPreference: "high-performance", preserveDrawingBuffer: true });
    document.body.appendChild(this.domElement);
    this.setPixelRatio(this.currentPixelRatio);
    this.setSize(window.innerWidth, window.innerHeight);
    this.setupListeners();
  }

  setupListeners = () => {
    window.addEventListener("resize", () => {
      this.setSize(window.innerWidth, window.innerHeight);

      this.setPixelRatio(this.currentPixelRatio);
    });
  };

  mainRender = (
    scene: Scene,
    camera: PerspectiveCamera,
    backgroundTexture: Texture
  ) => {

    scene.background = backgroundTexture;
    this.render(scene, camera);
  };
}
